// An expanded combobox consumes Escape before the F02 dialog stack receives it.
// The next Escape, after the list closes, remains owned by the enclosing dialog.
const entries = new WeakMap();
export default {
  bind(element, binding) {
    const entry = { close: binding.value };
    entry.handler = event => {
      if (event.key !== 'Escape' || event.isComposing || document.activeElement !== element || element.getAttribute('aria-expanded') !== 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      entry.close();
    };
    entries.set(element, entry);
    window.addEventListener('keydown', entry.handler, true);
  },
  update(element, binding) { entries.get(element).close = binding.value; },
  unbind(element) {
    window.removeEventListener('keydown', entries.get(element).handler, true);
    entries.delete(element);
  },
};
